// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__2CQBc","title":"AfterFrontImage_title__3tYXO"};